export { default as FileIcon } from './js/FileIcon';
